<div class="modal-container" #modalContainer>
  <div class="modal-header">
    <h3 class="modal-title">
      {{ title }}
    </h3>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="modal-body" tabindex="0" #modalContent>
      <formly-form [fields]="fields" [options]="formOptions" [form]="form"></formly-form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="cancel()">
        Cancel
      </button>
      &nbsp;
      <button type="submit" class="btn btn-primary">
        Add
      </button>
    </div>
  </form>
</div>
